import React, { useState, useEffect } from 'react';
import './CollectionDSO.scss';
import { useCollectionReport } from '../../../Hooks/useCollectionReport';
import { fetchCollectionDSO } from '../../../Api/request/collectionDSO';
import UseAxios from '../../../Api/http/http';
import { formatYear, getCurrentFinancialYear } from './utils';
import { MIS_COLLECTION_REPORT } from '../../../Constants/strings';
import YearPicker from '../../../Components/YearPicker/YearPicker';

const CollectionDSO = () => {
  const { empDetails, createDownloadAllHandler } = useCollectionReport();
  const [dso, setDso] = useState(null);
  const [financialYear, setFinancialYear] = useState(() =>
    getCurrentFinancialYear(),
  );
  const [visible, setVisible] = useState(false);

  const fetchDSOData = async (userInfo) => {
    try {
      const res = await UseAxios(fetchCollectionDSO({ userInfo }));
      const dsoValue = res.data?.data?.tableData?.[0]?.['DSO (Days)'] ?? 0;
      setDso(dsoValue);
      return res.data?.data?.tableData;
    } catch (error) {
      console.log(error);
    }
  };

  const handleDateChange = (date) => {
    const userInfo = { ...empDetails, financialYear: formatYear(date.value) };
    fetchDSOData(userInfo);
    setFinancialYear(date.value);
  };

  useEffect(() => {
    const userInfo = {
      ...empDetails,
      financialYear: formatYear(financialYear),
    };
    fetchDSOData(userInfo);
  }, []);

  useEffect(() => {
    createDownloadAllHandler(MIS_COLLECTION_REPORT.DSO, async () => {
      const userInfo = {
        ...empDetails,
        financialYear: formatYear(financialYear),
      };
      return await fetchDSOData(userInfo);
    });
  }, [financialYear]);

  const handleVisibleChange = () => setVisible((prev) => !prev);

  return (
    <div className="dso-outer-layer">
      <YearPicker
        inputClassName={'dso-date-input'}
        value={financialYear}
        onChange={handleDateChange}
        visible={visible}
        onVisibleChange={handleVisibleChange}
        formatYear={formatYear}
        containerClassName={'dso-date-picker'}
      />
      <p className="dso-value-container">
        DSO - <span className="dso-value">{dso}</span>
      </p>
    </div>
  );
};

export default CollectionDSO;
